export { default, getServerSideProps } from './DownloadableDetail';
